import { useMutation } from '@tanstack/react-query';
import { policiesService } from '../../../services/policies';

interface SendPolicyEmailParams {
  policyId: string;
  email: string;
}

export function useSendPolicyEmail() {
  return useMutation({
    retry: false,
    mutationFn: ({ policyId, email }: SendPolicyEmailParams) =>
      policiesService.sendPolicyEmail(policyId, email),
  });
}
